import { css } from 'wiloke-react-core';

export const label = css`
  debug: HelpTextField__label;
  display: flex;
  align-items: center;
  cursor: pointer;
`;
